import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { HEC_CONSTANTS } from '../../../utilities/constants';
import { LoaderService } from '../../sharedServices/loader.service';
import { SharedService } from '../../sharedServices/shared.service';
import { ForeignAttestationDetailComponent } from '../modal/foreign-attestation-detail/foreign-attestation-detail.component';

@Component({
  selector: 'kt-attestation-degree-details',
  templateUrl: './attestation-degree-details.component.html',
  styleUrls: ['./attestation-degree-details.component.css']
})
export class AttestationDegreeDetailsComponent implements OnInit {
  public degreeList: Array<any> = [];
  @Input('usercnic')usercnic;
  @Input('stampNumber')stampNumber;
  @Input('attestationTypeCodeId')attestationTypeCodeId;
  public foreignEmbassyCodes = HEC_CONSTANTS.FOREIGN_EMBASSY_DOWNLOAD_CODES

  constructor(private loaderService:LoaderService, private cdr:ChangeDetectorRef, private sharedService:SharedService,
    private matDialog: MatDialog,) { }

  ngOnInit() {
    this.search();
  }


  search() {
    this.loaderService.setValue(true)
    this.cdr.detectChanges();
    if (this.stampNumber != undefined || this.usercnic != undefined) {
      this.degreeList = [];
      let payload = {
        data: {
          cnic: this.usercnic,
          stampNumber: this.stampNumber,
          attestationTypeCodeId: this.attestationTypeCodeId,
        }
      }
      this.sharedService.searchDasEmbassyData(payload).subscribe(
        (res) => {
          if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
            this.degreeList = res.data;
            this.loaderService.setValue(false)
            this.cdr.detectChanges();
            this.cdr.markForCheck()
            if (this.degreeList.length == 0) {
              // this.isAlertVisible = true;
              this.sharedService
              .openPopupDialog(
                'ERROR',
                HEC_CONSTANTS.MESSGAES_LIST.ForeignEmbassyMessages.NO_RESULT,
                HEC_CONSTANTS.ERROR_TYPES.error
              )
              .then((res) => {
              });
            }
            
          } else {
            // this.isAlertVisible = true;
            this.sharedService
              .openPopupDialog(
                'ERROR',
                HEC_CONSTANTS.MESSGAES_LIST.ForeignEmbassyMessages.CONTACT_ADMIN,
                HEC_CONSTANTS.ERROR_TYPES.error
              )
              .then((res) => {
              });
            this.loaderService.setValue(false)
            this.cdr.detectChanges();
          }
        },
        (err) => {
          // this.isAlertVisible = true;
          this.sharedService
              .openPopupDialog(
                'ERROR',
                HEC_CONSTANTS.MESSGAES_LIST.ForeignEmbassyMessages.CONTACT_ADMIN,
                HEC_CONSTANTS.ERROR_TYPES.error
              )
              .then((res) => {
              });
          this.loaderService.setValue(false)
          this.cdr.detectChanges();
        }
      );
    }
  }

  showData(application) {
    this.readDetails(ForeignAttestationDetailComponent, 'Attestation Details', application)
  }

  public readDetails(Component, title, details): any {
    const dialogRef = this.matDialog.open(Component, {
      width: '70vw',
      height: '60vh',
      backdropClass: 'instruction-popups',
      panelClass: 'instruction-popup',
      disableClose: true,
      autoFocus: false,
      data: { title: title, details: details, }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }


  download(formName, stampNum?) {
    this.loaderService.setValue(true)
    this.cdr.detectChanges();
    let base64 = '';
    let payload;
    if (this.foreignEmbassyCodes.CNIC == formName) {
      payload = {
        CNIC: this.usercnic,
        ATTESTATION_TYPE_NAME: 'Original'
      }
    } 
    else if (this.foreignEmbassyCodes.STAMP_NO == formName) {
      payload = {
        STAMP_NO: stampNum,
        ATTESTATION_TYPE_NAME: 'Original'
     }
    }
    this.sharedService.downloadPdf(payload, formName).subscribe(
      (res) => {
        if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          this.loaderService.setValue(false);
          this.cdr.detectChanges()
          base64 = res.data;
          this.sharedService.showPdf(formName, base64);
        }
        else {
          this.loaderService.setValue(false);
          this.cdr.detectChanges()
          // this.isAlertVisible = true;
          this.sharedService
              .openPopupDialog(
                'ERROR',
                HEC_CONSTANTS.MESSGAES_LIST.SOMETHING_LATER_ERROR,
                HEC_CONSTANTS.ERROR_TYPES.error
              )
              .then((res) => {
              });
          this.loaderService.setValue(false);
          this.cdr.detectChanges()

        //  this._snackBar.open(HEC_CONSTANTS.MESSGAES_LIST.SOMETHING_LATER_ERROR, '', {
        //     duration: 9500,
        //     panelClass: ['error-snackbar']
        //   });
          this.cdr.detectChanges()

        }
      },
      (err) => {
        this.loaderService.setValue(false);
        this.sharedService
        .openPopupDialog(
          'ERROR',
          HEC_CONSTANTS.MESSGAES_LIST.SOMETHING_LATER_ERROR,
          HEC_CONSTANTS.ERROR_TYPES.error
        )
        .then((res) => {
        });
        this.cdr.detectChanges()

      }
    )
  }

}
